import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ErrorCodesEnum } from '~/core/services/error-code/enums/codes.enum';
import { ErrorCodeService } from '~/core/services/error-code/error-code.service';
import { OrganizerSharedAbstractGuard } from '~/organizer/shared/guards/guard.abstract';
import { OrganizerSharedOrganizationService } from '~/organizer/shared/services/organization/organization.service';

@Injectable({
  providedIn: 'root',
})
class PermissionsService extends OrganizerSharedAbstractGuard {
  protected readonly errorCode =
    ErrorCodesEnum.OrganizerSharedGetOrganizationFromAuthUser;

  constructor(
    private readonly organizationService: OrganizerSharedOrganizationService,
    protected readonly errorCodeService: ErrorCodeService,
    protected readonly router: Router
  ) {
    super(errorCodeService, router);
  }

  canActivate(): Observable<boolean> | true {
    if (this.organizationService.organization) {
      return true;
    }

    return this.organizationService.getOrganizationFromAuthUser().pipe(
      map(() => true),
      catchError((error) => {
        this.catchError();
        return throwError(() => error);
      })
    );
  }
}

export const OrganizerSharedGetOrganizationFromAuthUserGuard: CanActivateFn =
  (): Observable<boolean> | true => {
    return inject(PermissionsService).canActivate();
  };
